export { Iconify101 } from "./Iconify101";
